"use client"
import {FiltersActief} from "partials/support/Kenniscentrum//FiltersActief/FiltersActief";
import FilterInhoud from "partials/support/Kenniscentrum//FilterInhoud/FilterInhoud";
import FilterBookmarked from "partials/support/Kenniscentrum//FilterBookmarked/FilterBookmarked";
import {FilterVideo} from "partials/support/Kenniscentrum//FilterVideo/FilterVideo";
import FilterAutorisatie from "partials/support/Kenniscentrum//FilterAutorisatie/FilterAutorisatie";
import FilterType from "partials/support/Kenniscentrum//FIlterType/FilterType";
import classes from './Kenniscentrum.module.scss';
import {FilterCategorieen} from "partials/support/Kenniscentrum//FilterCategorie/FilterCategorieen";
import FilterProduct from "partials/support/Kenniscentrum//FilterProduct/FilterProduct";
import {FilterKenmerk} from "../../../../../../partials/support/Kenniscentrum/FilterKenmerk/FilterKenmerk";


export const KennisCentrumFilters = () => {


    return <div className={classes.filters}>

        <FiltersActief />


        <FilterInhoud />


        {/*Losse-Filters : Favorieten en Video*/}
        <>
            <FilterBookmarked />
            <FilterVideo />
            <div className={`border-b border-kleur-licht-grijs-blauw pb-[20px] mb-[20px]`} />
        </>


        <FilterAutorisatie  />


        <FilterKenmerk />

        <FilterProduct
            classLine={classes.line}
            prClassName={classes.checkWithCount}
            classSubcheck={classes.subCheck}
            classToggle={classes.toggle}
        />


        <FilterType
            classNameMeer={classes.meer}
            className={classes.checkWithCount}
        />


        <FilterCategorieen
            basepath={'/mijn-mkg/support/kenniscentrum'}
            classNameMeer={classes.meer}
            className={classes.checkWithCount}
            classLine={classes.line}
        />


    </div>
}